// Cart Timer Controller
(function() {
  'use strict';
  
  const CONFIG = {
    TIMER_KEY: 'cart_reservation_end_time',
    DURATION: 5 * 60 * 1000,
    WARNING_THRESHOLD: 100 * 1000,
    UPDATE_INTERVAL: 1000
  };
  
  let timerInterval = null;
  let resetTimeout = null;
  let isWatching = false;
  
  function getTimerElement() {
    return document.getElementById('cart-timer');
  }
  
  function getContainerElement() {
    return document.getElementById('cart-timer-container');
  }
  
  function getRemainingTime() {
    const endTimeStr = localStorage.getItem(CONFIG.TIMER_KEY);
    const isExpired = localStorage.getItem(CONFIG.TIMER_KEY + '_expired');
    
    if (isExpired === 'true') {
      localStorage.removeItem(CONFIG.TIMER_KEY + '_expired');
      localStorage.removeItem(CONFIG.TIMER_KEY);
      return CONFIG.DURATION;
    }
    
    if (!endTimeStr) {
      return CONFIG.DURATION;
    }
    
    const endTime = new Date(endTimeStr);
    const remaining = Math.max(0, endTime - new Date());
    
    return remaining;
  }
  
  function formatTime(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  
  function updateVisualState(remaining) {
    const containerEl = getContainerElement();
    if (!containerEl) return;
    
    containerEl.classList.remove('warning', 'expired');
    
    if (remaining === 0) {
      containerEl.classList.add('expired');
    } else if (remaining <= CONFIG.WARNING_THRESHOLD) {
      containerEl.classList.add('warning');
    }
  }
  
  function onTimerExpired() {
    localStorage.setItem(CONFIG.TIMER_KEY + '_expired', 'true');
    localStorage.removeItem(CONFIG.TIMER_KEY);
    
    const containerEl = getContainerElement();
    const contentDiv = document.querySelector('.cart-timer-content');
    
    if (contentDiv) {
      const allSpans = contentDiv.querySelectorAll('span');
      allSpans.forEach(span => span.style.display = 'none');
      
      const svg = contentDiv.querySelector('svg');
      if (svg) svg.style.display = 'none';
      
      let msgSpan = contentDiv.querySelector('.expiration-message');
      if (!msgSpan) {
        msgSpan = document.createElement('span');
        msgSpan.className = 'expiration-message';
        msgSpan.style.textAlign = 'center';
        msgSpan.style.width = '100%';
        contentDiv.appendChild(msgSpan);
      }
      msgSpan.textContent = 'Reservierung abgelaufen - bitte Seite neu laden';
      msgSpan.style.display = 'block';
    }
    
    if (containerEl) {
      containerEl.classList.add('expired');
    }
    
    document.dispatchEvent(new CustomEvent('cart-timer-expired', {
      detail: { timestamp: new Date() }
    }));
  }
  
  function restoreTimerDisplay() {
    const contentDiv = document.querySelector('.cart-timer-content');
    if (!contentDiv) return;
    
    const allSpans = contentDiv.querySelectorAll('span:not(.expiration-message)');
    allSpans.forEach(span => span.style.display = '');
    
    const svg = contentDiv.querySelector('svg');
    if (svg) svg.style.display = '';
    
    const msgSpan = contentDiv.querySelector('.expiration-message');
    if (msgSpan) {
      msgSpan.style.display = 'none';
    }
    
    const containerEl = getContainerElement();
    if (containerEl) {
      containerEl.classList.remove('expired', 'warning');
    }
  }
  
  function startTimer() {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
    
    const timerEl = getTimerElement();
    if (!timerEl) return;
    
    const remaining = getRemainingTime();
    
    if (remaining === 0) {
      onTimerExpired();
      return;
    }
    
    restoreTimerDisplay();
    
    const endTime = new Date(Date.now() + remaining);
    localStorage.setItem(CONFIG.TIMER_KEY, endTime.toISOString());
    
    timerEl.textContent = formatTime(remaining);
    updateVisualState(remaining);
    
    timerInterval = setInterval(() => {
      const now = new Date();
      const diff = Math.max(0, endTime - now);
      
      if (diff === 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        onTimerExpired();
        return;
      }
      
      const currentTimerEl = getTimerElement();
      if (currentTimerEl) {
        currentTimerEl.textContent = formatTime(diff);
      }
      
      updateVisualState(diff);
    }, CONFIG.UPDATE_INTERVAL);
  }
  
  function resetTimer() {
    if (resetTimeout) {
      clearTimeout(resetTimeout);
    }
    
    resetTimeout = setTimeout(() => {
      localStorage.removeItem(CONFIG.TIMER_KEY);
      localStorage.removeItem(CONFIG.TIMER_KEY + '_expired');
      startTimer();
      resetTimeout = null;
    }, 100);
  }
  
  function stopTimer() {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
    localStorage.removeItem(CONFIG.TIMER_KEY);
  }
  
  function hasCartItems() {
    const cartCountEl = document.querySelector('.cart-count, [data-cart-count], .cart-count-bubble');
    if (cartCountEl) {
      const count = parseInt(cartCountEl.textContent || cartCountEl.getAttribute('data-cart-count') || '0');
      if (count > 0) return true;
    }
    
    const savedTimer = localStorage.getItem(CONFIG.TIMER_KEY);
    const isExpired = localStorage.getItem(CONFIG.TIMER_KEY + '_expired');
    if (savedTimer && isExpired !== 'true') {
      return true;
    }
    
    const wrapperEl = document.getElementById('basket-timer-wrapper');
    if (wrapperEl) {
      const cartCount = parseInt(wrapperEl.getAttribute('data-cart-item-count') || '0');
      if (cartCount > 0) return true;
    }
    
    return false;
  }
  
  function startWatching() {
    if (isWatching) return;
    isWatching = true;
    
    const observer = new MutationObserver(function(mutations) {
      const timerEl = getTimerElement();
      if (timerEl && !timerInterval && hasCartItems()) {
        startTimer();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  function setup() {
    document.addEventListener('ajaxProduct:added', function(e) {
      resetTimer();
    });
    
    if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function(data) {
        setTimeout(() => {
          if (hasCartItems()) {
            resetTimer();
          }
        }, 150);
      });
    }
    
    startWatching();
    
    const timerEl = getTimerElement();
    if (timerEl && hasCartItems()) {
      startTimer();
    }
    
    window.cartTimer = {
      start: startTimer,
      reset: resetTimer,
      stop: stopTimer,
      getRemaining: getRemainingTime
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  
})();